<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">

            <div class="clearfix"></div>
            <div class="mb-2 text-center">
              <button @click="report_view = 1" class="fw-bold btn me-2"
                :class="{ 'btn-dark': report_view == 1, 'btn-primary btn-sm': report_view != 1 }">Summary</button>
              <button @click="report_view = 3" class="fw-bold btn"
                :class="{ 'btn-dark': report_view == 3, 'btn-primary btn-sm': report_view != 3 }">Details</button>
            </div>
            <div class="summary" v-if="report_view == 1">
              <hr>
              <div class="d-flex justify-content-between">
                <div class="card bg-primary text-white me-1" style="width: 18rem;">
                  <div class="card-body">
                    <h5 class="fs-4 text-white fw-bold">{{ stockreport.length }}</h5>
                    <p class="card-text">Products</p>
                  </div>
                </div>
                <div class="card bg-success text-white" style="width: 18rem;">
                  <div class="card-body">
                    <h5 class="fs-4 text-white fw-bold">{{ totalBatches.total }}</h5>
                    <p class="card-text">Batches</p>
                  </div>
                </div>
                <div class="card bg-dark text-white ms-1" style="width: 18rem;">
                  <div class="card-body">
                    <h5 class="fs-4 text-white fw-bold">{{ commas(totalBatches.totalValue) }}/=</h5>
                    <p class="card-text">Stock Value</p>
                  </div>
                </div>
              </div>
              <br>
              <div class="row">
                <div class="col-4 products">
                  <h4>Products Summary</h4>
                  <hr>
                  <div class="row mb-3 fs-5">
                    <div class="col-6">In Stock:</div>
                    <div class="col-6">{{ inStockProducts }}</div>
                  </div>
                  <div class="row mb-3 fs-5">
                    <div class="col-6">Out of Stock:</div>
                    <div class="col-6">{{ Number(stockreport.length) - Number(inStockProducts) }}</div>
                  </div>
                  <div class="row mb-3 fs-5">
                    <div class="col-6">With Expired Batches:</div>
                    <div class="col-6">{{ productsWithExpiredBatches }}</div>
                  </div>
                </div>
                <div class="col-4 batches">
                  <h4>Batches Summary</h4>
                  <hr>
                  <div class="row mb-3 fs-5">
                    <div class="col-6">Active Batches:</div>
                    <div class="col-6">{{ activeBatches }}</div>
                  </div>
                  <div class="row mb-3 fs-5">
                    <div class="col-6">Inactive Batches:</div>
                    <div class="col-6">{{ Number(totalBatches.total) - Number(activeBatches) }}</div>
                  </div>
                  <div class="row mb-3 fs-5">
                    <div class="col-6">Expired Batches:</div>
                    <div class="col-6">{{ expiredBatches.expired }}</div>
                  </div>
                </div>
                <div class="col-4 value">
                  <h4>Stock Value Summary</h4>
                  <hr>
                  <div class="row mb-3 fs-5">
                    <div class="col-6">Functioning Batches Value:</div>
                    <div class="col-6">{{ commas(totalBatches.totalValue - expiredBatches.expiredValue) }}/=</div>
                  </div>
                  <div class="row mb-3 fs-5">
                    <div class="col-6">Expired Batches Value:</div>
                    <div class="col-6">{{ commas(expiredBatches.expiredValue) }}/=</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="details" v-if="report_view == 2">
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show
                      <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm"
                        :options="Options"></b-form-select>
                      entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                    <label class="d-inline-flex align-items-center">
                      Search:
                      <b-form-input v-model="filter" type="search" placeholder="Search..."
                        class="form-control form-control-sm ms-2"></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <b-table :items="Items" :fields="Fields" responsive="sm" :per-page="perPage" :current-page="currentPage"
                  :filter="filter" :filter-included-fields="filterOn" @filtered="Filtered" :busy="IsBusy">
                  <template #table-busy>
                    <div class="text-center text-primary my-2">
                      <b-spinner class="align-middle" type="grow" small></b-spinner>
                      <strong>No Data Found</strong>
                    </div>
                  </template>
                  <template #cell(index)="data">
                    {{ data.index + 1 }}
                  </template>
                  <!-- <template #cell(activity)="data">
                  {{ commas(data.item.activity) }}
                </template> -->
                </b-table>
                <!-- <div class="total-payments">
                <strong>Total Payments:</strong> {{ commas(totalPayments) }}
              </div> -->
              </div>
              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage">
                      </b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="report_view == 3" class="coming-soon text-center">
              <hr>
              <h3 class="text-danger" style="margin-bottom: -20px;">Coming Soon</h3>
              <img style="z-index:-10;" src="@/assets/images/coming-soon.svg" alt="Coming Soon" width="40%">
              <p style="margin-top:-10px;" class="text-muted">This feature is not yet available.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
// import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { stockreportMethods, stockreportComputed } from "../../../state/helpers";
// import { reportexpenseMethods, reportexpenseComputed } from "@/state/helpers";

export default {
  page: {
    title: "Stock Report",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "STOCK Report",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "STOCK Report", active: true },
      ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "user_name", label: "User", visible: true },
        { key: "activity", label: "Activity", visible: true },
        { key: "addedon", label: "Date", visible: true },
      ],
      datefrom: new Date().toLocaleDateString("fr-CA"),
      dateto: new Date().toLocaleDateString("fr-CA"),
      report_view: 1,
    };
  },
  computed: {
    // ...reportexpenseComputed,
    ...stockreportComputed,
    List() {
      return this.stockreport.length;
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.stockreport.map((d) => ({ ...d }));
    },
    IsBusy() {
      let a = false;
      if (this.stockreport.length > 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },
    totalBatches() {
      let total = 0;
      let totalValue = 0;
      this.stockreport.forEach((item) => {
        item.batches.forEach((batch) => {
          totalValue += batch.quantity * batch.buying_price;
        });
      });
      this.stockreport.forEach((item) => {
        total += item.batches.length;
      });
      return {
        total: total,
        totalValue: totalValue,
      }
    },

    inStockProducts() {
      let inStock = 0;
      this.stockreport.forEach((product) => {
        if (product.batches.length > 0) {
          const hasQuantity = product.batches.some((batch) => batch.quantity > 0);
          if (hasQuantity) {
            inStock++;
          }
        }
      });
      return inStock;
    },

    activeBatches() {
      let active = 0;
      this.stockreport.forEach((product) => {
        if (product.batches.length > 0) {
          product.batches.forEach((batch) => {
            if (batch.active == 1) {
              active++;
            }
          });
        }
      });
      return active;
    },

    expiredBatches() {
      let expired = 0;
      let expiredValue = 0;
      this.stockreport.forEach((product) => {
        if (product.batches.length > 0) {
          product.batches.forEach((batch) => {
            const expiryDate = new Date(batch.expiry_date);
            if (expiryDate < new Date()) {
              expiredValue += batch.quantity * batch.buying_price;
              expired++;
            }
          });
        }
      });
      return {
        expired: expired,
        expiredValue: expiredValue,
      };
    },

    productsWithExpiredBatches() {
      let expired = 0;
      this.stockreport.forEach((product) => {
        if (product.batches.length > 0) {
          const hasExpired = product.batches.some((batch) => {
            const expiryDate = new Date(batch.expiry_date);
            return expiryDate < new Date();
          });
          if (hasExpired) {
            expired++;
          }
        }
      });
      return expired;
    },
  },

  mounted() {
    // this.fetchReportExpense();
    this.fetchStockReport();
    this.TotalRows = this.stockreport.length;
    this.isBusy = false;
  },

  methods: {
    // ...reportexpenseMethods,
    ...stockreportMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    FilterData() {
      this.filterStockReport({
        datefrom: this.datefrom,
        dateto: this.dateto,
      });
    },
    commas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>
